import { init as initApm } from '@elastic/apm-rum';

export default config => {
  if (JSON.parse(config.APM_ENABLED)) {
    initApm({
      active: JSON.parse(config.APM_ENABLED),
      serviceName: config.APM_SERVICE_NAME,
      serverUrl: config.APM_SERVER_URL,
      serviceVersion: config.APM_SERVICE_VERSION,
      environment: config.APM_ENVIRONMENT,
    });
  }
};
